/* global branch */
import { loop, Effects } from 'redux-loop';
import createActions from 'modules/create-actions';
import { createReducer } from 'redux-act';
import { fromJS } from 'immutable';
import { cleanInput, validatePhoneNumber, statuses } from './utils';


export const initialState = fromJS({
  inputValue: '',
  status: statuses.INITIAL,
});


export const Actions = createActions('TextAppForm', [
  'sendSmsStart', 'sendSmsSuccess', 'sendSmsFailure',
  'updateInputValue',
]);


export const Api = {
  sendSms: (phoneNumber) => {
    const sendPromise = new Promise((resolve, reject) => {
      branch.sendSMS(
        phoneNumber,
        { channel: 'Website', feature: 'Text-Me-The-App' },
        { make_new_link: false },
        (error) => {
          if (error) reject(error);
          else resolve();
        },
      );
    });

    return sendPromise
      .then(() => Actions.sendSmsSuccess())
      .catch(() => Actions.sendSmsFailure());
  },
};


export const reducer = createReducer({
  [Actions.updateInputValue](state, input) {
    return state
      .set('inputValue', input);
  },
  [Actions.sendSmsStart](state) {
    const canSend = validatePhoneNumber(state.get('inputValue')) &&
      state.get('status') !== statuses.SUCCESS;

    if (!canSend) return state;

    const cleanedInput = cleanInput(state.get('inputValue'));

    return loop(
      state.set('status', statuses.SENDING),
      Effects.promise(Api.sendSms, cleanedInput)
    );
  },
  [Actions.sendSmsSuccess](state) {
    return state
      .set('status', statuses.SUCCESS);
  },
  [Actions.sendSmsFailure](state) {
    return state
      .set('status', statuses.ERROR);
  },
}, initialState);



/** WEBPACK FOOTER **
 ** ./shared-components/TextAppForm/reducer.js
 **/